import { CreateInvitationRequest as CreateInvitationRequestCore } from '@amzn/coral_com-amazon-passportusermanagementservice';
import { modelRegistrySingleton } from '@amzn/ihm-js-coral-client';
import FULLY_QUALIFIED_TYPE_NAMES from '../constants/coralOperationTypes';
/**
 * Extended class to override the serialization behavior and modify the type definition.
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */

class CreateInvitationRequest extends CreateInvitationRequestCore {
  static toJson({
    invitationChannelInfo,
    locale,
    requestedPermissionsList,
    logisticsPartyId,
  }) {
    return new CreateInvitationRequest(
      {
        ...invitationChannelInfo,
        __type: FULLY_QUALIFIED_TYPE_NAMES.EmailInvitationChannelInfo,
      },
      locale,
      null,
      null,
      null,
      logisticsPartyId,
      // Passing requestedPermissionList with required permissions to be granted as soon as new user accepts invitation
      requestedPermissionsList?.map((requestedPermissions) => ({
        ...(requestedPermissions
          ? {
              ...requestedPermissions,
              permissionKeyList:
                requestedPermissions?.permissionKeyList?.map(
                  (permissionKey) => ({
                    ...permissionKey,
                    __type:
                      Object.getPrototypeOf(permissionKey)?.constructor
                        ?.fullyQualifiedTypeName ?? '',
                  })
                ) ?? [],
            }
          : {}),
      })) ?? []
    );
  }
}

CreateInvitationRequest.fullyQualifiedTypeName =
  FULLY_QUALIFIED_TYPE_NAMES.CreateInvitationRequest;
// Register concrete types for serialization/deserialization
modelRegistrySingleton.registerType(CreateInvitationRequest);
export default CreateInvitationRequest;
